import React from 'react'
import { ProductCard } from 'react-ui-cards'
import './Portfolio.scss'

const Portfolio = () => {
    return (
        <div id='splash'>
            {/*<h2>Projects</h2>*/}
            <div className='styles__card-container'>
                <ProductCard
                    photos={[
                        './images/portfolio/k-clusters.gif'
                    ]}
                    productName='K-Nearest Neighbors'
                    description='A mapping project to find similar zipcodes based on US Census variables and ML Model'
                    url='/neighbors'
                    buttonText='View Project'
                />
                <ProductCard
                    photos={[
                        './images/portfolio/matadepera.gif'
                    ]}
                    productName='Matadepera'
                    description='A visual GIS project where indices for urban quality were calculated and corresponding layers visualized using Leaflet'
                    url='/matadepera'
                    buttonText='View Project'
                />
                <ProductCard
                    photos={[
                        './images/portfolio/subway_map.png'
                    ]}
                    productName='Subway Paths'
                    description='A project to engage with Income Inequality along the path of the New York City Subway.'
                    url='/subway'
                    buttonText='View Project'
                />
                <ProductCard
                    photos={[
                        './images/portfolio/Race_Map.gif'
                    ]}
                    productName='US Census API'
                    description='Explore Demographic and Economic variables from the US Census as Interactive Graphs.'
                    url='http://estado.us:3002'
                    buttonText='View Project'
                />
                <ProductCard
                    photos={[
                        './images/portfolio/heart_rate_monitors.png'
                    ]}
                    productName='Ocelot'
                    description='A visualization platform to monitor patient state and determine clinical patterns.'
                    url='http://estado.us:3002/ocelot'
                    buttonText='View Project'
                />
                <ProductCard
                    photos={[
                        './images/portfolio/bogota-animated.gif'
                    ]}
                    productName='Bogota Neighborhoods'
                    description='An interactive showcase of my favorite spots in Bogota.'
                    url='/bogota'
                    buttonText='View Project'
                />
                <ProductCard
                    photos={[
                        './images/portfolio/time_extraction_of_patient_paths.png'
                    ]}
                    productName='Walking Paths'
                    description='Visualize the walking path of an individual using geolocational data. Measure distance travelled using interactive brush.'
                    url='https://github.com/gabrielaldana87'
                />
                <ProductCard
                    photos={[
                        './images/portfolio/network_diagram.png'
                    ]}
                    productName='Network Diagram'
                    description='Discover a social network of interactions amongst users with group clusters to showcase communities.'
                    url='https://github.com/gabrielaldana87'
                />
            </div>
    </div>
    )
}

export default Portfolio
